import React, { Component } from 'react';
import { Link, ActionSheet } from 'core';
import { IcoActionMenu } from 'icons';
import { css, theme } from 'constants';

const underlayColor = theme.gray_color_alpha(0.1);
const styles = css({
  menu: {
    width: 50,
    height: 50,
    borderRadius: 25,
    alignItems: 'center',
    justifyContent: 'center'
  },
  focused: {
    backgroundColor: underlayColor
  }
});

export class ASButton extends Component {
  state = {};
  onDismiss = () => this.setState({ focused: false });
  onShow = event => {
    const { style, onPress, Icon, ...props } = this.props;
    (onPress && onPress(event)) || ActionSheet.show({ event, onDismiss: this.onDismiss, ...props });
    this.setState({ focused: true });
  };
  render() {
    const { style, onPress, Icon } = this.props;
    return (
      <Link
        highlight
        style={[styles.menu, this.state.focused && styles.focused, style]}
        icon={Icon || IcoActionMenu}
        color={'#666'}
        underlayColor={underlayColor}
        icon_attr={{ selected: true }}
        onPress={this.onShow}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/core/action_sheet_button.js